import { HoverCard } from "@mantine/core";
import { CSSProperties } from "react";

import { fontSizes } from "#app/theme/v1/fontSizes";
import { spacing } from "#app/theme/v1/spacing";
import { Icon } from "#shared/icons/Icon";
import { Box } from "#shared/view/components/Box";
import { Group } from "#shared/view/components/Group";
import { Space } from "#shared/view/components/Space";
import { Text } from "#shared/view/components/Text";
import { TextInput } from "#shared/view/designSystem/inputs/TextInput";
import { formatPrice } from "shared";

type Props = {
  value: number | string;
  helper?: string;
  label?: string;
  leftSign?: string;
  align?: "start" | "center" | "end";
  highlight?: boolean;
};

const FONT_WEIGHT = 24;
const INPUT_HEIGHT = 36;

export const ComputingResult = ({
  value,
  helper,
  label,
  leftSign = undefined,
  align = "end",
  highlight = false,
}: Props) => {
  return (
    <Group align={align} gap={"xxs"}>
      {leftSign && <Text pb={(INPUT_HEIGHT - FONT_WEIGHT) / 2}>{leftSign}</Text>}
      <Box>
        <Text style={label ? styles.label : styles.hiddenLabel} fz={fontSizes.small}>
          {label ? label : "hidden"}
        </Text>

        <TextInput
          disabled
          value={typeof value === "number" ? formatPrice(value) : value}
          highlight={highlight}
        />

        {helper && (
          <>
            <Space w="xxs" />
            <HoverCard shadow="md">
              <HoverCard.Target>
                <Box>
                  <Icon name="infoCircle" />
                </Box>
              </HoverCard.Target>
              <HoverCard.Dropdown>
                <Text>{helper}</Text>
              </HoverCard.Dropdown>
            </HoverCard>
          </>
        )}
      </Box>
    </Group>
  );
};

const styles: Record<string, CSSProperties> = {
  hiddenLabel: {
    visibility: "hidden",
    marginBottom: spacing.xxxs,
  },
  label: {
    marginBottom: spacing.xxxs,
  },
};
